<p-toast key="app-analytics-error" position="top-right"></p-toast>
<p-dialog [(visible)]="showFilterOptions" [modal]="true" [blockScroll]="true" [showHeader]="true"
          header="Application Logs Filter"
          [draggable]="false"
          [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
          [style]="{width: '25%'}">
    <!--    Filter Part-->
    <div class="p-grid p-py-2 p-ai-center" [formGroup]="analyticsFilterForm">
        <div class="p-col-12">
            <div class="p-field">
                <label>From Date*</label>
                <p-calendar appendTo="body" [baseZIndex]="100" [readonlyInput]="true" [monthNavigator]="true"
                            showButtonBar="true"
                            clearButtonStyleClass="p-d-none"
                            styleClass="width-100" dateFormat="dd-M-yy" [showTime]="true"
                            formControlName="fromLogDateTime"
                            [showIcon]="true"></p-calendar>
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <label>To Date*</label>
                <p-calendar appendTo="body" [baseZIndex]="100" [readonlyInput]="true" [monthNavigator]="true"
                            showButtonBar="true"
                            clearButtonStyleClass="p-d-none"
                            styleClass="width-100" dateFormat="dd-M-yy" [showTime]="true"
                            formControlName="toLogDateTime"
                            [showIcon]="true"></p-calendar>
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <label>Page Title</label>
                <p-dropdown appendTo="body"
                            [options]="pageTitles" placeholder="Select.."
                            [showClear]="analyticsFilterForm?.value.pageTitle" formControlName="pageTitle"
                            emptyMessage="No Page Titles Found"></p-dropdown>
                <!--                <input pInputText class="width-100" formControlName="pageTitle">-->
            </div>
        </div>
        <div class="p-col-12">
            <div class="p-field">
                <label>Customer</label>
                <p-dropdown [showClear]="analyticsFilterForm?.value?.businessEntity" filterBy="entityName" filter="true"
                            appendTo="body" placeholder="Select.." styleClass="width-100" [options]="businessEntities"
                            optionLabel="entityName"
                            formControlName="businessEntity"></p-dropdown>
            </div>

        </div>

        <div class="p-col-12">
            <div class="p-field">
                <label>Domain</label>
                <p-dropdown [showClear]="analyticsFilterForm?.value?.domain" appendTo="body" placeholder="Select.."
                            styleClass="width-100" [options]="domains" optionLabel="domainName"
                            formControlName="domain"></p-dropdown>
            </div>

        </div>
        <div class="p-col-12 p-text-right">
            <button (click)="getFilteredApplicationLogs(); showFilterOptions = false;" pButton pRipple label="Search"
                    class="p-button-secondary"></button>
        </div>

    </div>
</p-dialog>
<div class="p-pt-3">
    <!--    <div class="card p-shadow-4">-->

    <!--        <h5 class="p-m-0 p-text-primary">Application Analytics</h5>-->

    <!--    </div>-->
    <div *ngIf="environment === 'dev'">
        <div class="p-py-5 p-text-center">
            <h5 class="p-m-0 p-text-secondary">Application Analytics Not Available on Dev Environment</h5>
        </div>
    </div>


    <div *ngIf="environment !== 'dev'">
        <p-tabView>

            <!--            <p-tabPanel header="Graphs">-->
            <!--                <div class="card">-->
            <!--                    <h5 class="p-m-0 p-text-primary">Page Title with User's</h5>-->
            <!--                    <p-chart type="line" [data]="emailAndPageTitleData" [options]="basicOptions"></p-chart>-->
            <!--                </div>-->
            <!--            </p-tabPanel>-->

            <p-tabPanel header="Web Analytics Listing">
                <div class="p-d-flex pi-align-center p-jc-end">
                    <div [formGroup]="analyticsFilterForm" class="p-d-flex p-ai-center">
                        <div>
                            Environment:
                        </div>
                        <div class="p-ml-1">
                            <p-dropdown (onChange)="getFilteredApplicationLogs()" formControlName="environment"
                                        appendTo="body"
                                        [options]="envOptions" optionValue="envValue"
                                        optionLabel="envDisplay"></p-dropdown>
                        </div>
                    </div>

                    <div class="p-ml-2 p-mt-2">
                        <img class="p-cursor" (click)="showFilterOptions = true"
                             src="assets/branding/shared-icons/filter-secondary.svg" alt="" pRipple
                             style="height: calc(1.5rem + 1vmin);">
                    </div>
                </div>
                <div class="p-mt-2 card p-shadow-4">

                    <div class="p-grid divider-bottom">
                        <div class="p-col-6">
                            <h5 class="p-text-primary p-m-0">Application Logs</h5>
                        </div>
                        <div class="p-col-6 p-text-right" *ngIf="isExecuted">
                            <img *ngIf="!isDownloading" pRipple (click)="exportExcel()" class="fp-icon-height p-cursor"
                                 src="assets/branding/shared-icons/export-excel.svg"
                                 alt="excel-export">
                            <i *ngIf="isDownloading" class="pi pi-spin pi-spinner p-text-secondary"
                               style="font-size: 1.75rem"></i>
                        </div>
                    </div>

                    <div class="p-text-center p-py-5" *ngIf="isLoading">
                        <div>
                            <i class="pi pi-spinner pi-spin p-text-secondary" style="font-size: 1.5rem;"></i>
                        </div>
                        <div class="p-pt-3">
                            <div class="p-text-secondary">
                                Loading Analytics Logs
                            </div>
                        </div>
                    </div>

                    <div class="p-text-center p-py-5" *ngIf="!isLoading && applicationLogs?.content?.length === 0">
                        <div class="p-pt-3">
                            <div class="p-text-secondary">
                                No Analytics Logs Found !
                            </div>
                        </div>
                    </div>

                    <div class="p-text-center p-py-5" *ngIf="!isExecuted">
                        <div class="p-pt-3">
                            <div class="p-text-secondary p-text-bold">
                                Please Execute to get Logs
                            </div>
                            <div class="p-mt-5">
                                <button pButton pRipple class="p-button-secondary" label="Execute"
                                        (click)="getFilteredApplicationLogs()"></button>
                            </div>
                        </div>
                    </div>

                    <p-table *ngIf="!isLoading && applicationLogs?.content?.length > 0" styleClass="min-height-logs"
                             [scrollable]="true" [value]="applicationLogs?.content"
                             [rows]="10">
                        <!--                        [showCurrentPageReport]="false"-->
                        <!--                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">-->

                        <ng-template pTemplate="header">
                            <tr>
                                <th class="p-py-3" style="width: 210px">Email Id</th>
                                <th style="width: 150px">Name</th>
                                <th style="width: 170px">Log Date</th>
                                <th style="width: 200px">Domain</th>
                                <th style="width: 200px">Customer</th>
                                <th style="width: 130px">Customer UID</th>
                                <th style="width: 150px">User Location</th>
                                <th style="width: 150px">Page Title</th>
                                <th style="width: 200px">Page Url</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-applicationLog>
                            <tr class="divider-bottom">
                                <td style="width: 210px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                    class="p-py-3">{{applicationLog.emailId ? applicationLog.emailId : '-'}}</td>
                                <td style="width: 150px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{(applicationLog?.firstName ? applicationLog?.firstName : '') + '&nbsp;' + (applicationLog?.lastName ? applicationLog?.lastName : '')}}</td>
                                <td style="width: 170px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{applicationLog.logDateTime ? (applicationLog.logDateTime | date: 'dd-MMM-yyyy h:mm a') : '-'}}</td>

                                <td style="width: 200px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                    <div *ngIf="applicationLog?.userDomains?.length === 0 || !applicationLog?.userDomains">
                                        All Domains Assigned
                                    </div>
                                    <div class="p-text-bold p-text-secondary"
                                         *ngIf="applicationLog?.userDomains?.length === 18">
                                        All Domains Assigned
                                    </div>
                                    <div *ngIf="applicationLog?.userDomains?.length < 17">
                                        <div class="p-pt-2"
                                             *ngFor="let domain of applicationLog?.userDomains">
                                            {{domain?.domainName}} <span class="p-text-bold">({{domain?.domainId}}
                                            )</span>
                                        </div>
                                    </div>
                                </td>

                                <td style="width: 200px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                    <div *ngIf="applicationLog?.userBusinessEntities?.length === 0 || !applicationLog?.userBusinessEntities">
                                        -
                                    </div>
                                    <div class="p-pt-2 p-text-secondary"
                                         *ngFor="let businessEntity of applicationLog?.userBusinessEntities">
                                        {{businessEntity?.entityName}}
                                    </div>
                                </td>

                                <td style="width: 130px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                    <div *ngIf="applicationLog?.userBusinessEntities?.length === 0 || !applicationLog?.userBusinessEntities">
                                        -
                                    </div>
                                    <div class="p-pt-2 p-text-secondary"
                                         *ngFor="let businessEntity of applicationLog?.userBusinessEntities">
                                        {{businessEntity?.entityId}}
                                    </div>
                                </td>


                                <td style="width: 150px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                    {{applicationLog?.regionName ? applicationLog?.regionName + ' - ' + applicationLog?.countryCode : '-'}}
                                </td>

                                <td style="width: 150px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{applicationLog.pageTitle ? applicationLog.pageTitle : '-'}}</td>
                                <td style="width: 200px"
                                    [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{applicationLog.pageView ? applicationLog.pageView : '-'}}</td>

                            </tr>
                        </ng-template>
                    </p-table>

                    <div *ngIf="isExecuted">
                        <p-paginator #logsPaginator rows="10" [totalRecords]="applicationLogs?.totalElements"
                                     (onPageChange)="onPaginate($event)"></p-paginator>
                    </div>
                </div>


            </p-tabPanel>
        </p-tabView>
    </div>

</div>
